module.exports = __webpack_public_path__ + "img/snippets.20e5bf0c.svg";